import {createContext, useState, useEffect, useCallback, useContext, useMemo} from 'react';

export const ThemeContext = createContext({
    theme: 'light',
    toggleTheme: () => {},
});

const THEMES = {
    LIGHT: 'light',
    DARK: 'dark',
};

export const ThemeProvider = ({ children }) => {

    const getInitialTheme = () => {
        const WebApp = window.Telegram?.WebApp;
        const telegramScheme = WebApp?.colorScheme;
        if (telegramScheme === THEMES.DARK) {
            return THEMES.DARK;
        }
        return THEMES.LIGHT;
    };

    const [theme, setTheme] = useState(getInitialTheme);

    useEffect(() => {
        const root = document.documentElement; // <html> tag
        root.classList.remove(theme === THEMES.LIGHT ? THEMES.DARK : THEMES.LIGHT);
        root.classList.add(theme);
        // document.documentElement.setAttribute('data-theme', theme);
        // document.classList.remove(theme);
        // document.classList.add(theme);
        window.localStorage.setItem('app-theme', theme);
    }, [theme]);

    const toggleTheme = () => {
        setTheme(prevTheme =>
            prevTheme === THEMES.LIGHT ? THEMES.DARK : THEMES.LIGHT
        );
    };

    const contextValue = useMemo(() => ({ theme, toggleTheme }), [theme]);

    return (
        <ThemeContext.Provider value={contextValue}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    // Проверка, что хук используется внутри провайдера
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
